export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Index.vue?vue&type=template&id=563a51b6&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/HighwaySection/Index.vue?vue&type=template&id=563a51b6&scoped=true
// module id = 2708
// module chunks = 31